var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEitaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eitaa-icon-colorful 1",
    clipPath: "url(#clip0_7186_1969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 7.62194e-05H20C24.4004 7.62194e-05 28 3.50739 28 7.80076V11.5655C24.0553 13.2957 20.076 21.8408 14.2761 19.984C13.7984 20.3152 12.6973 21.6803 12.6201 22.7159C10.6117 22.455 8.29638 20.2092 8.57423 17.7874C5.23146 15.4281 7.9919 11.0729 10.6427 9.31989C16.324 5.56273 24.2113 8.79398 19.824 11.4803C17.1563 13.1138 11.4515 14.1928 12.0446 10.1828C10.4797 10.6232 9.478 13.4704 11.3622 14.9541C9.61673 16.6274 9.9523 19.7031 11.818 20.713C13.7049 15.9427 20.2723 16.5661 22.9257 10.8716C24.922 6.58803 21.9623 1.70716 16.0446 2.45694C11.5786 3.02287 7.39238 6.69886 5.2988 11.0587C3.17459 15.4822 3.49071 21.4056 7.85255 24.3909C12.9857 27.904 18.4508 24.651 21.7607 20.3994C23.7118 17.8934 25.4164 15.1174 28 13.5139V20.1886C28 24.4819 24.3999 28.0001 20 28.0001H8.00002C3.59999 28.0001 0 24.4873 0 20.194V7.8061C0 3.51273 3.59999 0 8.00002 0V7.62194e-05Z",
    fill: "#EE7F22"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7186_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEitaa);
export default __webpack_public_path__ + "static/media/eitaa.0ae39fdab3b95ed5ebf17b69da302ab6.svg";
export { ForwardRef as ReactComponent };